import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

type NotificationVariant = 'default' | 'error' | 'success' | 'warning' | 'info';

export const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const addNotification = (
    id: string,
    variant: NotificationVariant,
    message: string,
    closable?: boolean
  ) =>
    enqueueSnackbar(message, {
      key: id,
      variant: variant,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      action: closable
        ? () => (
            <span
              onClick={() => closeSnackbar(id)}
              style={{ cursor: 'pointer' }}
            >
              <CloseIcon />
            </span>
          )
        : null,
      preventDuplicate: true
    });
  return { addNotification };
};
